import React, { Component } from 'react';
import Steps from '../../../components/Steps/Steps';
import { manualDataEntrySteps } from '../../../utils/constants';
import DatePicker from "react-datepicker";
import {Row, Col, Label, FormText, Button} from 'reactstrap';
import moment from 'moment';
import Select from "react-select";


class SelectDate extends Component {

  openDatePicker = (id) => {
    document.getElementById(id).click();
  }

  

  render() { 
    return ( 
      <div className="mt30">
        <div className="title-text">
          Manual Data Entry
        </div>
        <Steps
          steps={manualDataEntrySteps}
          currentStep={1}
        />
        <div className="mt40 manual-entry-instruction"> 
          Please select a date for which you will be filling out 
          information in the form.
        </div>

       
        <span className="manual-entry-instruction_inputs">
          <div className="row mt40">
            <div className="upload-file-type-lable offset-md-3 offset-lg-3 col-md-1 col-lg-1">
              Date
            </div>
            <div className="col-md-3 col-lg-3">
              <div className="inner-addon right-addon">
                <span className="tool-start-date flaticon-calendar" onClick={() => this.openDatePicker("selectManualEntryDate")} />
                <DatePicker
                  id="selectManualEntryDate"
                  className="input-custom-date form-control"
                  // readOnly
                  showYearDropdown
                  onChange={this.props.onDateChanged}
                  selected={this.props.selectedDate}
                  maxDate={moment()}
                />
              </div>
            </div>
          </div>

          <div className="row mt40">
            <div className="upload-file-type-lable offset-md-3 offset-lg-3 col-md-1 col-lg-1">
              Select Office
            </div>
            <div className="col-md-3 col-lg-3">
              <div className="inner-addon right-addon">
                <Select name="office-select" 
                  placeholder={"Select Office or Department..."} 
                  value={this.props.selectedOffice!==null? this.props.selectedOffice:""} 
                  isOpen={true}
                  options={this.props.flatHierarchy} 
                  isClearable={false}
                  onChange={
                    this.props.onOfficeSelect
                    // itm =>this.onOfficeSelect(itm)
                  }  
                  />
              </div>
            </div>
                  

          {this.props.error && this.props.error.status?
            <span className="error-msg">
              {this.props.error.msg}
            </span>
          :null}

            
        
          </div>

        </span>
       


        <Row className="mt40">
          <Col sm={{ size: '6', offset: 6 }}>
            <Col sm={{ size: '6', offset: 6 }}>
            <Button
              className="float-right continueBtn w100"
              onClick={this.props.onContinue}>
              <span className="continueBtnTxt">Continue <span className="ml10 flaticon-next"></span></span>
            </Button>
            </Col>
          </Col>
        </Row>
      </div>
    );
  }
}
 
export default SelectDate;